import { render } from "./MainHeaderLayout.vue?vue&type=template&id=fd2dfe6c"
import script from "./MainHeaderLayout.vue?vue&type=script&lang=js"
export * from "./MainHeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__